import { Label } from '@/components/ui/label';
import { Input } from '@/components/ui/input';
import { METAL_TYPES, METAL_COLOURS, METAL_KARATS } from '@/utils/constants';

export function TaskMetalTab({ formData, onChange, canEdit }) {
  return (
    <div className="space-y-6">
      <h3 className="text-lg font-semibold">Metal Specifications</h3>
      <div className="grid grid-cols-3 gap-6">
        <div>
          <Label htmlFor="metal_type">Metal Type</Label>
          <select id="metal_type" value={formData.metal_type}
            onChange={e => { onChange('metal_type', e.target.value); onChange('metal_colour', ''); onChange('metal_karat', ''); }}
            disabled={!canEdit}
            className="mt-2 w-full h-10 px-3 border border-slate-200 rounded-md bg-white focus:outline-none focus:ring-2 focus:ring-slate-900/10">
            <option value="">Select</option>
            {METAL_TYPES.map(m => <option key={m.value} value={m.value}>{m.label}</option>)}
          </select>
        </div>
        {formData.metal_type && (
          <>
            <div>
              <Label htmlFor="metal_colour">Colour</Label>
              <select id="metal_colour" value={formData.metal_colour} onChange={e => onChange('metal_colour', e.target.value)} disabled={!canEdit}
                className="mt-2 w-full h-10 px-3 border border-slate-200 rounded-md bg-white focus:outline-none focus:ring-2 focus:ring-slate-900/10">
                <option value="">Select</option>
                {METAL_COLOURS[formData.metal_type]?.map(c => <option key={c} value={c}>{c}</option>)}
              </select>
            </div>
            <div>
              <Label htmlFor="metal_karat">Karat</Label>
              <select id="metal_karat" value={formData.metal_karat} onChange={e => onChange('metal_karat', e.target.value)} disabled={!canEdit}
                className="mt-2 w-full h-10 px-3 border border-slate-200 rounded-md bg-white focus:outline-none focus:ring-2 focus:ring-slate-900/10">
                <option value="">Select</option>
                {METAL_KARATS[formData.metal_type]?.map(k => <option key={k} value={k}>{k}</option>)}
              </select>
            </div>
          </>
        )}
      </div>
      <div className="grid grid-cols-3 gap-6">
        <div>
          <Label htmlFor="gross_weight">Gross Weight (g)</Label>
          <Input id="gross_weight" type="number" step="0.01" value={formData.gross_weight} onChange={e => onChange('gross_weight', e.target.value)} disabled={!canEdit} className="mt-2" />
        </div>
        <div>
          <Label htmlFor="net_weight">Net Weight (g)</Label>
          <Input id="net_weight" type="number" step="0.01" value={formData.net_weight} onChange={e => onChange('net_weight', e.target.value)} disabled={!canEdit} className="mt-2" />
        </div>
        <div>
          <Label htmlFor="target_weight">Target Weight (g)</Label>
          <Input id="target_weight" type="number" step="0.01" value={formData.target_weight} onChange={e => onChange('target_weight', e.target.value)} disabled={!canEdit} className="mt-2" />
        </div>
      </div>
    </div>
  );
}
